import { globalV3dSettings } from '../data/visualize-3d-global-settings';
import { createStats, DebugStats } from './create-stats';
import { AxesHelper, Scene } from 'three';
import { createRendererStats, DebugRendererStats } from './create-renderer-stats';

export interface DebugItems {
  stats?: DebugStats;
  rendererStats?: DebugRendererStats;
}

export function initVisualize3dDebug(scene: Scene, element: HTMLElement): DebugItems {
  const result: DebugItems = {};

  if (globalV3dSettings.showDebugStats) {
    const stats = createStats();
    const renderStats = createRendererStats();
    element.appendChild(stats.dom);
    element.appendChild(renderStats.domElement);

    result.stats = stats;
    result.rendererStats = renderStats;
  }
  if (globalV3dSettings.showDebugAxes) {
    // The X axis is red. The Y axis is green. The Z axis is blue.
    scene.add(new AxesHelper(5));
  }

  return result;
}
